export const updateInputTaskAnswer = ({ formState, field, id, value, }) => {
    const newInputTaskAnswers = formState.inputTaskAnswers.map((answer) => answer.clientId === id ? { ...answer, [field]: value } : answer);
    formState.setInputTaskAnswers(newInputTaskAnswers);
    return newInputTaskAnswers;
};
export const updateInputTaskAnswerTranslation = ({ formState, id, lang, value, }) => {
    formState.setInputTaskAnswers((prev) => prev.map((answer) => answer.clientId === id
        ? {
            ...answer,
            translations: {
                ...answer.translations,
                [lang]: value,
            },
        }
        : answer));
};
// export const validateInputTaskAnswers = ({
//   taskType,
//   taskAnswers,
//   setTaskAnswersError,
// }: {
//   taskType: string | number | null;
//   taskAnswers: AdminInputTaskAnswer[];
//   setTaskAnswersError: Dispatch<SetStateAction<string | null>>;
// }) => {
//   const correctAnswersAmount = taskAnswers.reduce(
//     (acc, current) => acc + (current.isCorrect ? 1 : 0),
//     0
//   );
//   switch (taskType) {
//     case 'single-selection':
//       if (correctAnswersAmount < 1) {
//         setTaskAnswersError(TASK_ANSWERS_ERRORS.minOneCorrectAnswerRequired);
//       } else if (correctAnswersAmount > 1) {
//         setTaskAnswersError(TASK_ANSWERS_ERRORS.onlyOneCorrectAnswerAllowed);
//       } else {
//         setTaskAnswersError(null);
//       }
//       break;
//     case 'multiple-selection':
//       if (correctAnswersAmount < 1) {
//         setTaskAnswersError(TASK_ANSWERS_ERRORS.minTwoCorrectAnswerRequired);
//       } else if (correctAnswersAmount === 1) {
//         setTaskAnswersError(TASK_ANSWERS_ERRORS.minTwoCorrectAnswerRequiredOrTaskTypeChange);
//       } else {
//         setTaskAnswersError(null);
//       }
//       break;
//     default:
//       setTaskAnswersError(null);
//   }
// };
